import React, { useState, useCallback, useEffect, useMemo, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import intl from 'react-intl-universal'
import { setProductGroupAttr,selectProductGroupAttr } from '../../store/reducers/cart'
import { Grid } from 'antd-mobile'
import { DownOutline, UpOutline } from 'antd-mobile-icons'
import styles from './index.module.less'
import defaultImg from '../../assets/images/def_view.png'
import { isImageFile } from '../../utils'

const INITIAL_STATE = {
    dropdownVisible: false,
    checkedAttr: {
        attr: null,
        subAttr: null
    },
    subAttrList: []
}

const GroupAttrContent = ({ attrRows = [], product, groupAttrRows = {} }) => {
    const [state, setState] = useState(INITIAL_STATE)
    const [groupStates, setGroupStates] = useState({})
    const dropdownRef = useRef(null)
    const dropdownDataRef = useRef(null)
    const dropdownRefs = useRef({})
    const dropdownDataRefs = useRef({})
    const dispatch = useDispatch()
    const initializedGroupsRef = useRef(new Set())
    const shouldUpdateCartRef = useRef(false)
    const isInitializingRef = useRef(false)

    const fromGroupAttr = useSelector(selectProductGroupAttr)
    console.log(fromGroupAttr, '////====fromGroupAttr====')

    // 更新购物车
    const updateCart = useCallback((arr) => {
        if (!arr || arr.length === 0) {
            return
        }
        const newAttr = {
            attrArr: arr,
            attrKeys: arr.map(item => item.productExtraAttrKey).join(','),
            subAttrKeys: arr.map(item => item.productExtraAttrSubKey).join(',')
        }
        dispatch(setProductGroupAttr(newAttr))
    }, [dispatch])

    // 定位下拉框位置的通用函数
    const positionDropdown = useCallback((dropdownElement, dataElement) => {
        if (!dropdownElement || !dataElement) return

        const modalContent = document.getElementsByClassName('jm-modal-content')[0]
        const mainContent = document.getElementsByClassName('jm-modal-main')[0]
        const mScrollTop = mainContent ? mainContent.scrollTop : modalContent?.scrollTop || 0

        dataElement.style.top = `${dropdownElement.offsetTop - mScrollTop}px`
        dataElement.style.left = `${dropdownElement.offsetLeft}px`
        dataElement.style.width = `${dropdownElement.offsetWidth}px`
    }, [])

    // 处理 attrRows 的下拉框位置
    useEffect(() => {
        if (state.dropdownVisible && dropdownRef.current && dropdownDataRef.current) {
            positionDropdown(dropdownRef.current, dropdownDataRef.current)
        }
    }, [state.dropdownVisible, positionDropdown])

    // 处理所有 group 的下拉框位置
    useEffect(() => {
        Object.keys(groupStates).forEach(groupKey => {
            const groupState = groupStates[groupKey]
            if (groupState?.dropdownVisible && dropdownRefs.current[groupKey] && dropdownDataRefs.current[groupKey]) {
                positionDropdown(dropdownRefs.current[groupKey], dropdownDataRefs.current[groupKey])
            }
        })
    }, [groupStates, positionDropdown])

    // 当用户选择后更新购物车
    useEffect(() => {
        // 跳过初始化阶段的调用
        if (!shouldUpdateCartRef.current || isInitializingRef.current) return
        shouldUpdateCartRef.current = false

        const allSelectedSubAttrs = Object.values(groupStates)
            .map(groupState => groupState?.checkedAttr?.subAttr)
            .filter(Boolean)
        
        if (allSelectedSubAttrs.length > 0) {
            updateCart(allSelectedSubAttrs)
        }
    }, [groupStates, updateCart])

    // ===== attrRows 相关逻辑 =====
    const isAttrSelected = useCallback((attr) => {
        return state.checkedAttr.attr?.attrKey === attr.attrKey
    }, [state.checkedAttr.attr])

    const isSubAttrSelected = useCallback((subAttr) => {
        return state.checkedAttr.subAttr?.productExtraAttrSubKey === subAttr.productExtraAttrSubKey
    }, [state.checkedAttr.subAttr])

    const handleAttrClick = useCallback((attr) => {
        setState(prev => ({
            ...prev,
            checkedAttr: { ...prev.checkedAttr, attr, subAttr: null },
            subAttrList: attr.subAttrList || []
        }))
        updateCart([])
    }, [updateCart])

    const handleSubAttrClick = useCallback((subAttr) => {
        setState(prev => ({
            ...prev,
            checkedAttr: { ...prev.checkedAttr, subAttr }
        }))
        updateCart([subAttr])
    }, [updateCart])

    // ===== groupAttrRows 相关逻辑 =====
    const handleGroupAttrClick = useCallback((groupKey, attr) => {
        setGroupStates(prev => ({
            ...prev,
            [groupKey]: {
                ...prev[groupKey],
                checkedAttr: {
                    ...(prev[groupKey]?.checkedAttr || {}),
                    attr,
                    subAttr: null
                },
                subAttrList: attr.subAttrList || [],
                dropdownVisible: false
            }
        }))

        const {attrArr = [], attrKeys = '', subAttrKeys = ''} = fromGroupAttr || {}
        const nList = attrArr.filter(item => item.groupKey !== attr.groupKey)

        console.log(nList,'////====nList====')

        const newAttr = {
            attrArr: nList,
            attrKeys: nList.map(item => item.productExtraAttrKey).join(','),
            subAttrKeys: nList.map(item => item.productExtraAttrSubKey).join(',')
        }
        console.log(newAttr,'////====newAttr====')
        dispatch(setProductGroupAttr(newAttr))
    }, [dispatch, fromGroupAttr])

    const handleGroupSubAttrClick = useCallback((groupKey, subAttr) => {
        shouldUpdateCartRef.current = true
        setGroupStates(prev => ({
            ...prev,
            [groupKey]: {
                ...prev[groupKey],
                checkedAttr: {
                    ...(prev[groupKey]?.checkedAttr || {}),
                    subAttr
                }
            }
        }))
    }, [])

    const isGroupAttrSelected = useCallback((groupKey, attr) => {
        return groupStates[groupKey]?.checkedAttr?.attr?.attrKey === attr.attrKey
    }, [groupStates])

    const isGroupSubAttrSelected = useCallback((groupKey, subAttr) => {
        return groupStates[groupKey]?.checkedAttr?.subAttr?.productExtraAttrSubKey === subAttr.productExtraAttrSubKey
    }, [groupStates])

    // ===== 渲染函数 =====
    const columns = useMemo(() => {
        if (state.subAttrList.length <= 10) return []
        return state.subAttrList.map(subAttr => ({
            label: subAttr.productExtraAttrSubName,
            value: subAttr.productExtraAttrSubKey,
            item: subAttr
        }))
    }, [state.subAttrList])

    // 渲染 attrRows 的子属性列表
    const renderSubAttrList = useCallback((subAttrList) => {
        if (!subAttrList || subAttrList.length === 0) return null

        if (subAttrList.length <= 10) {
            return subAttrList.map((subAttr, subIndex) => (
                <li
                    key={subAttr.productExtraAttrSubKey || subIndex}
                    className={isSubAttrSelected(subAttr) ? styles.current : ''}
                    onClick={() => handleSubAttrClick(subAttr)}
                >
                    {subAttr.productExtraAttrSubName}
                </li>
            ))
        }

        const { checkedAttr, dropdownVisible } = state
        const { subAttr } = checkedAttr || {}
        const ddValue = subAttr ? subAttr.productExtraAttrSubName : intl.get('pls_select').d('Please Select')

        return (
            <li style={{ width: '100%', color: '#000', border: 0, padding: 5 }}>
                <div className={`jm-flex ${styles.dropdownBox}`}>
                    <div className={styles.left}><span>&nbsp;</span></div>
                    <div className='jm-flex-item'>
                        <div
                            className={`${styles.dropdownList} jm-dropdown-com`}
                            onClick={() => setState(prev => ({ ...prev, dropdownVisible: true }))}
                            ref={dropdownRef}
                        >
                            <div className={styles.dropdownLabel}>{ddValue}</div>
                            <div><DownOutline fontSize={20} color='#4d4a49' /></div>
                        </div>
                        {dropdownVisible && (
                            <>
                                <div
                                    className={styles.dropdownMask}
                                    onClick={() => setState(prev => ({ ...prev, dropdownVisible: false }))}
                                />
                                <div
                                    ref={dropdownDataRef}
                                    className={styles.dropdownDataWrapper}
                                    onClick={e => e.stopPropagation()}
                                >
                                    <div
                                        className={styles.dataTitle}
                                        onClick={() => setState(prev => ({ ...prev, dropdownVisible: false }))}
                                    >
                                        <label className='jm-flex-item'>{ddValue}</label>
                                        <div><UpOutline fontSize={20} color='#4d4a49' /></div>
                                    </div>
                                    <div className={styles.dataBody}>
                                        {columns.map(data => (
                                            <div
                                                key={data.value}
                                                style={
                                                    subAttr?.productExtraAttrSubKey === data.value
                                                        ? { fontWeight: 'bold', color: 'var(--adm-color-primary)' }
                                                        : undefined
                                                }
                                                onClick={() => {
                                                    setState(prev => ({ ...prev, dropdownVisible: false }))
                                                    handleSubAttrClick(data.item)
                                                }}
                                            >
                                                {data.label}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </li>
        )
    }, [isSubAttrSelected, handleSubAttrClick, columns, state])

    // 渲染 group 的子属性列表
    const renderGroupSubAttrList = useCallback((groupKey, subAttrList) => {
        if (!subAttrList || subAttrList.length === 0) return null

        const groupState = groupStates[groupKey] || {}
        const { checkedAttr, dropdownVisible } = groupState
        const { subAttr } = checkedAttr || {}

        if (subAttrList.length <= 10) {
            return subAttrList.map((subAttrItem, subIndex) => (
                <li
                    key={subAttrItem.productExtraAttrSubKey || subIndex}
                    className={isGroupSubAttrSelected(groupKey, subAttrItem) ? styles.current : ''}
                    onClick={() => handleGroupSubAttrClick(groupKey, subAttrItem)}
                >
                    {subAttrItem.productExtraAttrSubName}
                </li>
            ))
        }

        const columns = subAttrList.map(subAttrItem => ({
            label: subAttrItem.productExtraAttrSubName,
            value: subAttrItem.productExtraAttrSubKey,
            item: subAttrItem
        }))
        const ddValue = subAttr ? subAttr.productExtraAttrSubName : intl.get('pls_select').d('Please Select')

        return (
            <li style={{ width: '100%', color: '#000', border: 0, padding: 5 }}>
                <div className={`jm-flex ${styles.dropdownBox}`}>
                    <div className={styles.left}><span>&nbsp;</span></div>
                    <div className='jm-flex-item'>
                        <div
                            className={`${styles.dropdownList} jm-dropdown-com`}
                            onClick={() => {
                                setGroupStates(prev => ({
                                    ...prev,
                                    [groupKey]: {
                                        ...prev[groupKey],
                                        dropdownVisible: true
                                    }
                                }))
                            }}
                            ref={el => { dropdownRefs.current[groupKey] = el }}
                        >
                            <div className={styles.dropdownLabel}>{ddValue}</div>
                            <div><DownOutline fontSize={20} color='#4d4a49' /></div>
                        </div>
                        {dropdownVisible && (
                            <>
                                <div
                                    className={styles.dropdownMask}
                                    onClick={() => {
                                        setGroupStates(prev => ({
                                            ...prev,
                                            [groupKey]: {
                                                ...prev[groupKey],
                                                dropdownVisible: false
                                            }
                                        }))
                                    }}
                                />
                                <div
                                    ref={el => { dropdownDataRefs.current[groupKey] = el }}
                                    className={styles.dropdownDataWrapper}
                                    onClick={e => e.stopPropagation()}
                                >
                                    <div
                                        className={styles.dataTitle}
                                        onClick={() => {
                                            setGroupStates(prev => ({
                                                ...prev,
                                                [groupKey]: {
                                                    ...prev[groupKey],
                                                    dropdownVisible: false
                                                }
                                            }))
                                        }}
                                    >
                                        <label className='jm-flex-item'>{ddValue}</label>
                                        <div><UpOutline fontSize={20} color='#4d4a49' /></div>
                                    </div>
                                    <div className={styles.dataBody}>
                                        {columns.map(data => (
                                            <div
                                                key={data.value}
                                                style={
                                                    subAttr?.productExtraAttrSubKey === data.value
                                                        ? { fontWeight: 'bold', color: 'var(--adm-color-primary)' }
                                                        : undefined
                                                }
                                                onClick={() => {
                                                    setGroupStates(prev => ({
                                                        ...prev,
                                                        [groupKey]: {
                                                            ...prev[groupKey],
                                                            dropdownVisible: false
                                                        }
                                                    }))
                                                    handleGroupSubAttrClick(groupKey, data.item)
                                                }}
                                            >
                                                {data.label}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </li>
        )
    }, [groupStates, isGroupSubAttrSelected, handleGroupSubAttrClick])

    // 渲染 attrRows 的属性网格
    const renderAttrGrid = useCallback(() => {
        if (!product?.attrs || product.attrs.length === 0) return null

        return (
            <Grid columns={2} gap={10}>
                {product.attrs.map((attr, index) => {
                    const isImage = attr.attrImages?.length > 0 && isImageFile(attr.attrImages)
                    return (
                        <div
                            key={attr.attrKey || index}
                            className={`${styles.attrItem} ${isAttrSelected(attr) ? styles.current : ''} ${isImage ? '' : styles.noneImage}`}
                            onClick={() => handleAttrClick(attr)}
                        >
                            {isImage && (
                                <div className={styles.attrImgBox}>
                                    <img
                                        src={attr.attrImages || defaultImg}
                                        alt={attr.attrName}
                                        onError={(e) => {
                                            e.target.src = defaultImg
                                        }}
                                    />
                                </div>
                            )}
                            <div className={styles.attrName}>
                                {attr.attrName}
                            </div>
                        </div>
                    )
                })}
            </Grid>
        )
    }, [product?.attrs, isAttrSelected, handleAttrClick])

    // 渲染 group 的属性网格
    const renderGroupAttrGrid = useCallback((groupKey, attrs) => {
        if (!attrs || attrs.length === 0) return null

        return (
            <Grid columns={2} gap={10}>
                {attrs.map((attr, index) => {
                    const isImage = attr.attrImages?.length > 0 && isImageFile(attr.attrImages)
                    return (
                        <div
                            key={attr.attrKey || index}
                            className={`${styles.attrItem} ${isGroupAttrSelected(groupKey, attr) ? styles.current : ''} ${isImage ? '' : styles.noneImage}`}
                            onClick={() => handleGroupAttrClick(groupKey, attr)}
                        >
                            {isImage && (
                                <div className={styles.attrImgBox}>
                                    <img
                                        src={attr.attrImages || defaultImg}
                                        alt={attr.attrName}
                                        onError={(e) => {
                                            e.target.src = defaultImg
                                        }}
                                    />
                                </div>
                            )}
                            <div className={styles.attrName}>
                                {attr.attrName}
                            </div>
                        </div>
                    )
                })}
            </Grid>
        )
    }, [isGroupAttrSelected, handleGroupAttrClick])

    // ===== 初始化逻辑 =====
    // 初始化 attrRows (旧逻辑保留)
    /*
    useEffect(() => {
        if (product?.attrs?.length > 0) {
            const attr = product.attrs[0]
            const subAttrList = attr.subAttrList || []
            const subAttr = subAttrList[0]

            if (attr) {
                handleAttrClick(attr)
                if (subAttr) {
                    const timer = setTimeout(() => {
                        handleSubAttrClick(subAttr)
                    }, 100)
                    return () => clearTimeout(timer)
                }
            }
        }
    }, [product?.attrs, handleAttrClick, handleSubAttrClick])
    //*/

    // 初始化 groupAttrRows
    useEffect(() => {
        if (!groupAttrRows || Object.keys(groupAttrRows).length === 0) {
            return
        }

        const newGroupStates = {}
        let hasNewGroup = false

        Object.keys(groupAttrRows).forEach(groupKey => {
            // 跳过已经初始化的 group
            if (initializedGroupsRef.current.has(groupKey)) {
                return
            }

            const attrs = groupAttrRows[groupKey]
            if (attrs && attrs.length > 0) {
                const firstAttr = attrs[0]
                const firstSubAttr = firstAttr.subAttrList?.[0]
                if (firstAttr && firstSubAttr) {
                    newGroupStates[groupKey] = {
                        checkedAttr: {
                            attr: firstAttr,
                            subAttr: firstSubAttr
                        },
                        subAttrList: firstAttr.subAttrList || [],
                        dropdownVisible: false
                    }
                    initializedGroupsRef.current.add(groupKey)
                    hasNewGroup = true
                }
            }
        })

        if (hasNewGroup && Object.keys(newGroupStates).length > 0) {
            isInitializingRef.current = true
            setGroupStates(prev => ({ ...prev, ...newGroupStates }))
        }
    }, [groupAttrRows])

    // 初始化完成后更新购物车（只调用一次）
    useEffect(() => {
        if (!isInitializingRef.current) return
        if (Object.keys(groupStates).length === 0) return
        
        isInitializingRef.current = false
        
        const allSelectedSubAttrs = Object.values(groupStates)
            .map(groupState => groupState?.checkedAttr?.subAttr)
            .filter(Boolean)

        if (allSelectedSubAttrs.length > 0) {
            setTimeout(() => {
                updateCart(allSelectedSubAttrs)
            }, 0)
        }
    }, [groupStates, updateCart])

    // ===== 渲染 =====
    if (!groupAttrRows || Object.keys(groupAttrRows).length === 0) {
        return null
    }

    return (
        <div>
            {Object.keys(groupAttrRows).map(groupKey => {
                const attrs = groupAttrRows[groupKey]
                const groupNameParts = groupKey.split('@@')
                const groupState = groupStates[groupKey] || {}

                return (
                    <div key={groupKey}>
                        {groupNameParts.map((partName, partIndex) => {
                            if (partIndex === 0) {
                                // 第一部分：显示属性选择
                                return (
                                    <div key={`${groupKey}-${partIndex}`} className={styles.attrItem}>
                                        <div className={`${styles.attrTitle} ${styles.modalTitle}`}>{partName}</div>
                                        <div className={styles.attrBox}>
                                            {renderGroupAttrGrid(groupKey, attrs)}
                                        </div>
                                        {/* 如果只有一个部分，也显示子属性 */}
                                        {groupNameParts.length === 1 && (
                                            <ul className={styles.subAttrList}>
                                                {renderGroupSubAttrList(groupKey, groupState.subAttrList || [])}
                                            </ul>
                                        )}
                                    </div>
                                )
                            } else if (partIndex === 1) {
                                // 第二部分：显示子属性选择
                                return (
                                    <div key={`${groupKey}-${partIndex}`} className={styles.attrItem}>
                                        <div className={`${styles.attrTitle} ${styles.modalTitle}`}>{partName}</div>
                                        <ul className={styles.subAttrList}>
                                            {renderGroupSubAttrList(groupKey, groupState.subAttrList || [])}
                                        </ul>
                                    </div>
                                )
                            }
                            return null
                        })}
                    </div>
                )
            })}
        </div>
    )
}

export default React.memo(GroupAttrContent)
